import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap, catchError, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ContentService {
  private readonly http = inject(HttpClient);
  private _content: Record<string, any> = {};

  /** Called by APP_INITIALIZER — loads /assets/data/content.json once at startup. */
  preload(): Observable<any> {
    return this.http.get<Record<string, any>>('/assets/data/content.json').pipe(
      tap(data => (this._content = data)),
      catchError(() => of({}))
    );
  }

  /** Returns the content block for a given page key (e.g. 'home', 'products'). */
  page<T = any>(key: string): T {
    return (this._content[key] ?? {}) as T;
  }
}
